import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { storeOnsiteInterviews, type IRawOnsiteInterview } from '~/actions/PermanentJobs';
import { TOnsiteInterviewFormData } from '../../components';
import { CreateOnsiteInterviewSteps } from '../Types';
import { useSafeLocationState } from './useSafeLocationState';

export const useStoreOnsiteInterview = (jobPostingId: string | undefined) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSafeLocationState();

  const onSubmit = (formData: TOnsiteInterviewFormData) => {
    if (!jobPostingId) {
      return;
    }

    const payload = {
      breakTime: formData.breakTime,
      dates: formData.dates,
      hourlyRate: formData.hourlyRate,
      hoursArrival: formData.hoursArrival,
      hoursDeparture: formData.hoursDeparture,
      isAssistedHygiene: formData.isAssistedHygiene,
      isPaidBreakTime: formData.isPaidBreakTime,
      specialty: formData.specialty,
    } satisfies IRawOnsiteInterview;

    // Store onsite interviews (smart merge: appends if exists, creates if empty)
    dispatch(storeOnsiteInterviews(jobPostingId, payload));

    navigate(
      // eslint-disable-next-line max-len
      `/permanent-jobs/postings/${jobPostingId}/onsite-interviews/create/${CreateOnsiteInterviewSteps.Reviews}`,
      { state },
    );
  };

  return {
    onSubmit,
  };
};
